import { Routes, Route } from 'react-router-dom';
import { ToastProvider } from '../components/Toast';
import { useAuth } from '../auth/AuthProvider';
import { LockGate } from '../auth/LockGate';
import { Layout } from '../components/Layout';
import { LoginScreen } from '../screens/LoginScreen';
import { HomeScreen } from '../screens/HomeScreen';
import { DocumentiScreen } from '../screens/DocumentiScreen';
import { DettaglioDocumentoScreen } from '../screens/DettaglioDocumentoScreen';
import { GaranzieScreen } from '../screens/GaranzieScreen';
import { DettaglioGaranziaScreen } from '../screens/DettaglioGaranziaScreen';
import { NuovoScreen } from '../screens/NuovoScreen';
import { ProfiloScreen } from '../screens/ProfiloScreen';
import { ModificaProfiloScreen } from '../screens/ModificaProfiloScreen';
import { SicurezzaScreen } from '../screens/SicurezzaScreen';
import { ScadenzeScreen } from '../screens/ScadenzeScreen';
import { RicercaScreen } from '../screens/RicercaScreen';
import { FamiliariScreen } from '../screens/FamiliariScreen';
import { MemberProvider } from '../lib/members';
import { OnboardingGate } from '../screens/OnboardingScreen';
import { ScansioneScreen } from '../screens/ScansioneScreen';
import { ExportScreen } from '../screens/ExportScreen';

export function App() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="shell">
        <main className="shell__main">
          <div className="screen" style={{ paddingTop: 80, color: 'var(--muted)' }}>Caricamento…</div>
        </main>
      </div>
    );
  }

  // Backend raggiungibile ma senza sessione → schermata di accesso.
  if (status === 'anon') {
    return (
      <ToastProvider>
        <LoginScreen />
      </ToastProvider>
    );
  }

  // 'auth' (dati reali) oppure 'demo' (dataset locale): app completa.
  return (
    <ToastProvider>
      <LockGate>
        <MemberProvider>
        <OnboardingGate>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomeScreen />} />
            <Route path="documenti" element={<DocumentiScreen />} />
            <Route path="documenti/:id" element={<DettaglioDocumentoScreen />} />
            <Route path="garanzie" element={<GaranzieScreen />} />
            <Route path="garanzie/:id" element={<DettaglioGaranziaScreen />} />
            <Route path="nuovo" element={<NuovoScreen />} />
            <Route path="profilo" element={<ProfiloScreen />} />
            <Route path="profilo/modifica" element={<ModificaProfiloScreen />} />
            <Route path="profilo/sicurezza" element={<SicurezzaScreen />} />
            <Route path="scadenze" element={<ScadenzeScreen />} />
            <Route path="cerca" element={<RicercaScreen />} />
            <Route path="profilo/familiari" element={<FamiliariScreen />} />
            <Route path="profilo/export" element={<ExportScreen />} />
          </Route>
          {/* Scanner a tutto schermo: fuori dal Layout (niente tab bar). */}
          <Route path="scansiona" element={<ScansioneScreen />} />
        </Routes>
        </OnboardingGate>
        </MemberProvider>
      </LockGate>
    </ToastProvider>
  );
}
